module.exports = __webpack_public_path__ + "static/media/clouds.a6cdf74c.png";